import {Box, Button, Fab, IconButton, useMediaQuery, useTheme} from "@mui/material"
import SendMessage                                                                           from "../prepkit/chat/SendMessage"
import {
	GridViewOutlined,
	KeyboardArrowLeft,
	KeyboardArrowRight,
	KeyboardDoubleArrowRight
} from "@mui/icons-material"
import React, {useState}                                                                     from "react"
import {keyframes}                                                                           from "@emotion/react"


const bw = 0

// same pulse as the desktop Next button (mockup: A_Questions_v2 softPulse)
const softPulse = keyframes`
	0%, 100% { box-shadow: 0 0 0 0 rgba(99, 102, 241, 0.5); }
	50%      { box-shadow: 0 0 0 8px rgba(99, 102, 241, 0); }
`

const QuestionInput = ({currentAnswer, answered, messageInputDisabled, onSend, onBack, onNext, onDashboard}) => {

	const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down('md'))
	const theme = useTheme()
	const custom = theme.custom
	const [showNavigationButtons, setShowNavigationButtons] = useState(true)


	const handleSend = (msg) => {
		onSend(msg)
	}

	const fabSize = showNavigationButtons
		? isSmallScreen
			? "40px"
			: "normal"
		: 0

	const fabSx = {
		border: `1px solid divider`,
		backgroundColor: theme.palette.background.paper,
		//'&:hover': {
		//	border: `1.5px solid ${theme.palette.secondary.main}`
		//},
		//'&:hover .MuiSvgIcon-root': {
		//	color: theme.palette.secondary.main,
		//},
		'.MuiSvgIcon-root': {
			color: theme.palette.text.primary
		},
		boxShadow: 'none !important',
		width: fabSize,
		height: fabSize,
		opacity: showNavigationButtons ? 1 : 0,
		overflow: "hidden",
		mx: showNavigationButtons ? 0.5 : 0,
		transition: "width 250ms, opacity 250ms, margin 250ms",
	}

	return <Box sx={{
		position: "fixed",
		bottom: 0,
		left: 0,
		right: 0,
		maxWidth: '100vw',
		border: `${bw}px solid cyan`,
		zIndex: 1200,
		// keep the input/nav row clear of the iOS home indicator
		paddingBottom: 'env(safe-area-inset-bottom)',
		backgroundColor: isSmallScreen ? theme.palette.background.paper : "transparent"
	}}>
		{/* Quick-Start actions are not here — they flow in the page scroll (052) */}
		<Box
			sx={{
				py: isSmallScreen ? 1 : 2,
				width: isSmallScreen ? "auto" : "800px",
				marginX: "auto",
				border: `${bw}px solid dodgerblue`
			}}
			display="flex"
			justifyContent="center"
			alignItems="center"
		>
				{
				/* dashboard sits left of the input, same icon as the desktop nav row; it collapses
				 * with the other nav controls while the user is typing */
				onDashboard && showNavigationButtons &&
				<IconButton
					aria-label="Dashboard"
					onClick={onDashboard}
					sx={{flexShrink: 0, mr: 0.5, color: custom.text.muted}}
				>
					<GridViewOutlined/>
				</IconButton>
			}
			<Box display="flex"
			     flex={showNavigationButtons ? "auto" : 1}
			>
				<SendMessage
					onSend={handleSend}
					messageInputDisabled={messageInputDisabled}
					placeholder="Have a question? Enter it here."
					onFocusChange={(hasFocus) => {
						if(isSmallScreen) {
							setShowNavigationButtons(!hasFocus)
						}
						else {
							setShowNavigationButtons(true)
						}
					}}
				/>
			</Box>
		<Fab sx={[fabSx]}
			     onClick={onBack}
			     title="Previous question"
			>
				<KeyboardArrowLeft/>
			</Fab>
			{/* state button: Skip when unanswered, Next once answered */}
			<Button
				onClick={onNext}
				endIcon={
					answered
						? <KeyboardArrowRight sx={{fontSize: 18}}/>
						: <KeyboardDoubleArrowRight sx={{fontSize: 18}}/>
				}
				sx={{
					ml: 0.5,
					// keep it off the right edge of the screen
					mr: 1.5,
					animation: answered ? `${softPulse} 1.6s ease-in-out infinite` : 'none',
					flexShrink: 0,
					textTransform: 'none',
					borderRadius: `${custom.radius.sm}px`,
					px: 2.5, py: 1,
					fontWeight: custom.fontWeight.semibold,
					background: answered ? custom.indigo.primary : 'transparent',
					color: answered ? '#fff' : custom.text.muted,
					border: answered ? 'none' : `1px solid ${custom.border.strong}`,
					'&:hover': {background: answered ? custom.indigo.hover : custom.bg.dropdownHover},
				}}
			>
				{answered ? 'Next' : 'Skip'}
			</Button>
		</Box>
	</Box>
}

export default QuestionInput